import React from 'react';
import {
	Card,
	CardHeader,
	Divider,
	Grid,
	Table,
	TableBody,
	TableCell,
	TableRow,
	TableHead,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { formatCurrency } from 'src/utils/currency';

const useStyles = makeStyles((theme) => ({
	dialogTitleConatiner: {
		padding: theme.spacing(2),
		backgroundColor: theme.palette.primary.main,
	},
	dialogTitleText: {
		color: theme.palette.getContrastText(theme.palette.primary.dark),
		fontSize: theme.typography.h3.fontSize,
	},
	datePickerContainer: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-around',
		marginBottom: theme.spacing(2),
		marginTop: theme.spacing(2),
	},
	actionsContainer: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'right',
	},
	valueField: {
		width: '150px',
		textAlign: 'right',
	},
}));

function PoHistory({ purchaseOrderHistory }) {
	const classes = useStyles();

	if (purchaseOrderHistory == null) {
		return (<strong>No Purchase Order History</strong>);
	}


	const renderDetailRow = headerRow => {
		return (
			<Table>
				<TableHead>
					<TableCell>Field</TableCell>
					<TableCell>Operation</TableCell>
					<TableCell>Prior</TableCell>
					<TableCell>New</TableCell>
					<TableCell>Comments/Reasons</TableCell>
					<TableCell>MAP</TableCell>
				</TableHead>

				<TableBody>
					{headerRow.details.map(detail => {
						return (
							<TableRow key={detail.purchaseOrderHistoryDetailId}>
								<TableCell>{detail.fieldName}</TableCell>
								<TableCell>{detail.actionType}</TableCell>
								<TableCell>{detail.originalValue}</TableCell>
								<TableCell>{detail.newValue}</TableCell>
								<TableCell>{detail.reason}</TableCell>
								<TableCell>{detail.url}</TableCell>
							</TableRow>
						)
					})}
				</TableBody>
			</Table>
		)
	};

	return (
		purchaseOrderHistory.map(header => {
			return (
				<Grid key={header.purchaseOrderHistoryId} item xs={12} md={12}>
					<Card className={classes.card}>
						<CardHeader
							className={classes.cardHeader}
							title={(
								<Table>
									<TableHead>
										<TableRow>
											<TableCell>Date/Time</TableCell>
											<TableCell>User</TableCell>
											<TableCell>Type</TableCell>
											<TableCell>Description</TableCell>
											<TableCell>PO Amount</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										<TableRow>
											<TableCell>{header.createdDate}</TableCell>
											<TableCell>{header.createdBy}</TableCell>
											<TableCell>{header.purchaseOrderHistoryChangeTypeName}</TableCell>
											<TableCell>{`${header.details.length} changes made`}</TableCell>
											<TableCell>{formatCurrency(header.totalPurchaseOrderAmount)}</TableCell>
										</TableRow>
										<TableRow>
											<TableCell colSpan={4} sx={{ marginLeft: '75px' }}>
												{renderDetailRow(header)}
											</TableCell>
										</TableRow>
									</TableBody>
								</Table>
							)}
						/>
						<Divider />
					</Card>
				</Grid>
			)
		})
	);
}

PoHistory.propTypes = {
	purchaseOrderHistory: PropTypes.arrayOf(),
	availableCharges: PropTypes.arrayOf(
		PropTypes.shape({
			purchaseOrderChargeTypeId: PropTypes.Number,
			purchaseOrderChargeTypeName: PropTypes.string,
			isCalculated: PropTypes.bool,
			isExternalEditable: PropTypes.bool,
			isInternalEditable: PropTypes.bool,
		})
	),
	appliedCharges: PropTypes.arrayOf(
		PropTypes.shape({
			purchaseOrderChargeId: PropTypes.string,
			poNumber: PropTypes.number,
			purchaseOrderChargeTypeId: PropTypes.string,
			purchaseOrderChargeTypeName: PropTypes.string,
			amount: PropTypes.number,
			isCalculated: PropTypes.bool,
			isExternalEditable: PropTypes.bool,
			isInternalEditable: PropTypes.bool,
		})
	),
	//appliedCharges: PropTypes.arrayOf,
	isDialogOpen: PropTypes.bool,
	setIsDialogOpen: PropTypes.func,
	handleCustomDateRangeSave: PropTypes.func,
	purchaseOrderDetails: PropTypes.shape({
		AmountOwed: PropTypes.number,
		LoadedMileageRate: PropTypes.number,
		MilesLoaded: PropTypes.number,
		FreeLoadedMiles: PropTypes.number,
		UnloadedMileageRate: PropTypes.number,
		MilesUnloaded: PropTypes.number,
		FreeUnloadedMiles: PropTypes.number,
		StorageDailyRate: PropTypes.number,
		StorageDays: PropTypes.number,
	}),
	selectedCharge: PropTypes.shape({
		purchaseOrderChargeTypeId: PropTypes.number,
		purchaseOrderChargeTypeName: PropTypes.string,
		isCalculated: PropTypes.bool,
		isExternalEditable: PropTypes.bool,
		isInternalEditable: PropTypes.bool,
	}),
	setSelectedCharge: PropTypes.func,
	handleApply: PropTypes.func,
	isChargeReadOnly: PropTypes.bool,
	providerCategory: PropTypes.string,
};

export default PoHistory;
